import { WebUserDto } from '@repo/api/web/models'
import { defineStore } from 'pinia'

export type StateType = {
  _user: WebUserDto | null
}

export const useUserStore = defineStore('user', () => {
  const _state = reactive<StateType>({
    _user: null,
  })

  const user = computed(() =>
    _state._user ? WebUserDto.createLazy(_state._user) : null,
  )

  function setUser(user: WebUserDto | null) {
    _state._user = user
  }

  function reset() {
    setUser(null)
  }

  return {
    _state,
    user,

    setUser,
    reset,
  }
})
